@use "../../styles/breakpoint.module.scss" as *;
@use "../ProductCard/index.module" as productCard;

.grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--labui-grid-gap);
    composes: listReset from "../../styles/composable/utility.module.css";

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.card {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span productCard.$horizontal-row-span;
    gap: var(--spacer-24);
    padding: var(--spacer-16) var(--spacer-16) var(--spacer-24);
    background-color: var(--color-primary);
    border: 1px solid var(--gray-300);
    font: var(--font-nav-14);
}

.cardWithImage {
    composes: card;
    grid-template-areas:
        "image content"
        "image content"
        "image content"
        "image content";
    grid-template-columns: 2fr 3fr;

    &:hover {
        .picture {
            scale: 1.02;
        }
    }
}

.content {
    grid-area: content;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
}

.title {
    font: var(--font-h-24);
}

.picture {
    grid-area: image;
    align-self: center;
    position: relative;
    display: block;
    width: 100%;
    aspect-ratio: 4 / 3;
    overflow: hidden;
    transition: scale 0.2s;
}
